
import React, { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import imageUrl from "utils/imageUrl";
import { Modal } from "react-bootstrap";
import calls from "apis/calls";
import { useWeb3React } from "@web3-react/core";


const DataModel = (props) => {
  const [mintButton , setMintButton] = useState('MINT NOW')
  const [disable , setDisable] = useState(false)
  const [tx , setTx] = useState(0)
  const { active, activate, account , chainId , library} = useWeb3React();

  const handleModal = () => {
    props.onHide();
  };
  
  useEffect(() => {
   setTx(0)
    return () => {
    }
  }, [props.show])
  
  return (
       <>
      <Modal show={props.show} onHide={props.onHide} className={"modal-container"}>
    

        <div className="spa-modal-body modal-body space-y-20 pd-40">
          <button closeButton class="cs-close_modal cs-center cs-primary_bg" onClick={handleModal}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7071 1.70711C12.0976 1.31658 12.0976 0.683417 11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893L11.7071 1.70711ZM0.292893 10.2929C-0.0976311 10.6834 -0.0976311 11.3166 0.292893 11.7071C0.683417 12.0976 1.31658 12.0976 1.70711 11.7071L0.292893 10.2929ZM1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L1.70711 0.292893ZM10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L10.2929 11.7071ZM10.2929 0.292893L0.292893 10.2929L1.70711 11.7071L11.7071 1.70711L10.2929 0.292893ZM0.292893 1.70711L10.2929 11.7071L11.7071 10.2929L1.70711 0.292893L0.292893 1.70711Z" fill="white"></path>
          </svg>            
        </button>
         <h2 className="modal-heading text-uppercase text-center">Collect your NFT before 
         <br />the deadline.
         </h2>
          <div className="hr"></div>
          <div className="img d-flex justify-content-center my-5">
            <img src={imageUrl("1.png")} alt="congrats.png" className="vecel_img"/>
          
          </div>
         <ul className="ul">
          <li className="d-flex my-3">
            <div className="cs-list_left">Remaining</div>
            <div className="cs-list_right"> {Number(props?.data?.remaining)+tx} / {Number(props?.data?.totalSupply)} Minted</div>
          </li>
             <li className="d-flex justify-content-space-between my-3">
            <div className="cs-list_left">Price/NFT</div>
            <div className="cs-list_right">{props?.data?.price}</div>
          </li>
         </ul>

          <div className="d-flex justify-content-center align-items-center py-3">
          <button disabled={disable} onClick={async()=>{
                    
                    setMintButton("MINTING ...")
                    setDisable(true)
                    let call = await calls.mint('',library,chainId)
                    if(call){
                      setTx(tx+1)
                    }
                    setMintButton("MINT NOW")
                    setDisable(false)            
                  }} className="cs-btn cs-btn_filed cs-accent_btn">
                   {mintButton}
                  </button>
          </div>
          <p class="text-center">The collection has limited NFTs</p>
        </div>
      </Modal>
    
    </>
  )
}

export default DataModel